<!-- header.component.html -->
<header class="header-area {{route_path}} " [ngClass]="{ diff_header_area: isDiffHeadingClass }">
  <div class="header-content">
    <!-- Logo -->
    <div class="logo-wrapper">
      <a routerLink="{{isLocationSelected ? '' : ''}}" (click)="onHomePageClick()" class="logo-link">
        <img class="logo" [defaultImage]="'./assets/images/placeholder.jpg'" 
          [lazyLoad]="(data | async)?.restaurant_data?.logo ? (data | async)?.restaurant_data?.logo : 'https://s3.eu-west-2.amazonaws.com/contents.devoret/6731caede329c4a258b03b03/original-logo2.9a5e1e93.svg'" alt="{{(data | async)?.restaurant_data?.restaurant_name}}" />
      </a>
    </div>


    <!-- Desktop Navigation & Order Button -->
    <div class="header-actions">
      <button *ngIf="route_path !== 'choose-location' && route_path !== 'order-online'" class="order-btn d-none d-lg-block" (click)="onOrderOnlineClickedForRouting()">
        <span>Order Now</span>
      </button>

      <ng-container *ngIf="isLocationSelected && !isBusinessDataModeOn">
        <button *ngIf="route_path !== 'choose-location'" class="order-btn d-none d-lg-block change-location" (click)="onChoseLocationClickedForRouting()">
          <span>{{(data | async)?.restaurant_data?.city_or_town}}</span> <span class="sub-text">Change</span>
        </button>
      </ng-container>
      
      
      <!-- Hamburger Menu -->
      <button 
        class="hamburger" 
        [class.active]="isMenuOpen"
        (click)="toggleMenu()"
        aria-label="Toggle Menu">
        <span class="line line1"></span>
        <span class="line line2"></span>
        <span class="line line3"></span>
      </button>
    </div>
  </div>
</header>

<div class="custom-offcanvas {{isMenuOpen ? 'active-canvas' : ''}}">


  <div class="offcanvas-header-content">
      <!-- Logo -->
      <!-- <div class="logo-wrapper">
        <a href="/" class="logo-link">
          <img class="logo" [defaultImage]="'./assets/images/placeholder.jpg'" 
            [lazyLoad]="(data | async)?.restaurant_data?.logo ? (data | async)?.restaurant_data?.logo : 'https://s3.eu-west-2.amazonaws.com/contents.devoret/6731caede329c4a258b03b03/original-logo2.9a5e1e93.svg'" alt="{{(data | async)?.restaurant_data?.restaurant_name}}" />
        </a>
      </div> -->

      <button class="order-btn offcanvas-order-btn" *ngIf="route_path !== 'choose-location' && route_path !== 'order-online'" (click)="toggleAndChoseLocation()">
        <span>Order Now</span>
      </button>

      <ng-container *ngIf="isLocationSelected && !isBusinessDataModeOn">
        <button *ngIf="route_path !== 'choose-location'" class="order-btn change-location offcanvas-order-btn offcanvas-order-btn-lg" (click)="onChoseLocationClickedForRoutingWithToggle()">
          <span>{{(data | async)?.restaurant_data?.city_or_town}}</span> <span class="sub-text">Change</span>
        </button>
      </ng-container>


      <button 
          class="close-button" 
          [class.active]="isMenuOpen"
          (click)="toggleMenu()"
          aria-label="Toggle Menu">
          <span class="line line1"></span>
          <span class="line line2"></span>
      </button>
    </div>


    <div class="offcanvas-area-logo">
      <img class="logo" src="./assets/images/you-want-beef-white-logo.png" />
    </div>

    <div class="sm-screen-block">
      <ng-container *ngIf="isLocationSelected && !isBusinessDataModeOn">
        <button *ngIf="route_path !== 'choose-location'" class="order-btn change-location offcanvas-order-btn offcanvas-order-btn-sm" (click)="onChoseLocationClickedForRoutingWithToggle()">
          <span>{{(data | async)?.restaurant_data?.city_or_town}}</span> <span class="sub-text">Change</span>
        </button>
      </ng-container>
    </div>


  <div class="menu-wrapper">
    <!-- <ul class="navbar-nav mx-auto sub-font" *ngIf="!isLocationSelected" #menuList> -->
    <ul class="navbar-nav mx-auto sub-font" *ngIf="isBusinessDataModeOn" #menuList>
      <li class="nav-item" (click)="toggleMenu();">
          <a class="nav-link" data-hover="Home" routerLink="{{(isLocationSelected && !isBusinessDataModeOn) ? '/home' : ''}}" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }">
            <span>Home</span>
          </a>
      </li>
      <li class="nav-item" (click)="toggleMenu()">
          <a class="nav-link" data-hover="About" [routerLink]="['/about-us']" routerLinkActive="active">
            <span>About</span>
          </a>
      </li>
      <li class="nav-item" (click)="toggleMenu()">
          <a class="nav-link" data-hover="Menu" [routerLink]="['/menu']" routerLinkActive="active">
            <span>Menu</span>
          </a>
      </li>
      <li class="nav-item" (click)="toggleMenu()">
        <a class="nav-link" data-hover="Contact" [routerLink]="['/contact-us']" routerLinkActive="active">
          <span>Contact</span>
        </a>
      </li>
      <li class="nav-item" (click)="toggleMenu()">
        <a class="nav-link" data-hover="Franchise" [routerLink]="['/franchise']" routerLinkActive="active">
          <span>Franchise</span>
        </a>
      </li>
      <li class="nav-item" (click)="toggleMenu()">
        <a class="nav-link" data-hover="Choose Location" [routerLink]="['/choose-location']" routerLinkActive="active">
          <span>Choose Location</span>
        </a>
      </li>
      <!-- If location not selected show choose location page for a particular location -->
      <!-- show this button in mobile for some ui design  -->
      <!-- <li class="nav-item">
        <a class="nav-link" data-hover="Order Now" (click)="onChoseLocationClickedForRouting()">
          <span>Order online</span>
        </a>
      </li> -->
    </ul>
    <!-- <ul class="navbar-nav mx-auto sub-font" *ngIf="isLocationSelected" #menuList> -->
    <ul class="navbar-nav mx-auto sub-font" *ngIf="!isBusinessDataModeOn" #menuList>
      <!-- onHomePageClick() -->
      <li class="nav-item" (click)="toggleMenu();">
          <a class="nav-link" data-hover="Home" routerLink="{{(isLocationSelected && !isBusinessDataModeOn) ? '/home' : ''}}" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }">
            <span>Home</span>
          </a>
      </li>
      <li class="nav-item" (click)="toggleMenu()"
      *ngIf="(data | async)?.restaurant_content?.about_page?.is_active">
          <a class="nav-link" data-hover="About" [routerLink]="['/about-us']" routerLinkActive="active">
            <span>About</span>
          </a>
      </li>
      <li class="nav-item" (click)="toggleMenu()"
      *ngIf="(data | async)?.restaurant_content?.menu_page?.is_active">
          <a class="nav-link" data-hover="Menu" [routerLink]="['/menu']" routerLinkActive="active">
            <span>Menu</span>
          </a>
      </li>
      <li class="nav-item" (click)="toggleMenu()"
      *ngIf="(data | async)?.restaurant_content?.contact_page?.is_active">
        <a class="nav-link" data-hover="Contact" [routerLink]="['/contact-us']" routerLinkActive="active">
          <span>Contact</span>
        </a>
      </li>
      <li class="nav-item" (click)="toggleMenu()">
        <a class="nav-link" data-hover="Franchise" [routerLink]="['/franchise']" routerLinkActive="active">
          <span>Franchise</span>
        </a>
      </li>

      <li class="nav-item" (click)="toggleMenu()">
        <a class="nav-link" data-hover="Change Location" [routerLink]="['/choose-location']" routerLinkActive="active">
          <span>Change Location</span>
        </a>
      </li>
      <!-- <li class="nav-item">
        <a class="nav-link" data-hover="Order Now" (click)="onChoseLocationClickedForRouting()">
          <span>Order online</span>
        </a>
      </li> -->
      <li class="nav-item" (click)="toggleMenu()"
      *ngIf="(data | async)?.restaurant_data?.gift_voucher && (data | async)?.restaurant_content?.gift_voucher_page?.is_active">
        <a class="nav-link" data-hover="Gift Voucher" [routerLink]="['/gift-voucher']" routerLinkActive="active">
          <span>Gift Voucher</span>
        </a>
      </li>
      <li class="nav-item" (click)="toggleMenu()"
      *ngIf="(data | async)?.restaurant_data?.loyalty_program">
        <a class="nav-link" data-hover="Loyalty Rewards" [routerLink]="['/loyalty-program']" routerLinkActive="active">
          <span>Loyalty Rewards</span>
        </a>
      </li>
      <li class="nav-item" (click)="toggleMenu()"
      *ngIf="(data | async)?.restaurant_content?.deals_page?.is_active">
        <a class="nav-link" data-hover="Deals" [routerLink]="['/deals']" routerLinkActive="active">
          <span>Deals</span>
        </a>
      </li>
      <li class="nav-item" (click)="toggleMenu()"
      *ngIf="(data | async)?.restaurant_content?.gallery_page?.is_active">
        <a class="nav-link" data-hover="Gallery" [routerLink]="['/gallery']" routerLinkActive="active">
          <span>Gallery</span>
        </a>
      </li>
      <li class="nav-item" (click)="toggleMenu()" *ngIf="(user | async)?.isLogged === false">
        <a class="nav-link" data-hover="Sign In" [routerLink]="['/sign-in']" routerLinkActive="active">
          <span>Sign In</span>
        </a>
      </li>
      <li class="nav-item" (click)="toggleMenu()" *ngIf="(user | async)?.isLogged === true">
        <a class="nav-link" data-hover="My Account" [routerLink]="['/my-account']" routerLinkActive="active">
          <span>My Account</span>
        </a>
      </li>
      <li class="nav-item" (click)="signOut()" *ngIf="(user | async)?.isLogged === true">
        <a class="nav-link" data-hover="Log out" [routerLink]="">
          <span>Log out</span>
        </a>
      </li>
    </ul>
  </div>

  <div class="offcanvas-social" *ngIf="isBusinessDataModeOn">
    <ul>
      <ng-container *ngFor="let item of brand_socials">
        <li><a target="_blank" class="{{item?.media_name}}" href="{{item?.link}}"><i class="fi fi-brands-{{item?.media_name}}"></i></a></li>
      </ng-container>
      <!-- <li><a target="_blank" href=""><i class="fi fi-brands-facebook"></i></a></li>
      <li><a target="_blank" href=""><i class="fi fi-brands-instagram"></i></a></li>
      <li><a target="_blank" href=""><i class="fi fi-brands-tik-tok"></i></a></li> -->
    </ul>
  </div>

  <div class="offcanvas-social" *ngIf="!isBusinessDataModeOn">
    <ul *ngIf="restaurant_socials?.length">
      <ng-container *ngFor="let item of restaurant_socials">
        <li><a target="_blank" class="{{item?.media_name}}" href="{{item?.link}}"><i class="fi fi-brands-{{item?.media_name}}"></i></a></li>
      </ng-container>
    </ul>
  </div>


</div>